module.exports = __webpack_public_path__ + "img/OVCA_CD8T.1f5065bb.png";